<template>
  <div class="row">
    <div class="col-sm-7">
      <div class="order-number">
        Order #{{ order }}
      </div>
      <div class="order-date">
        Besteldatum: {{ orderDetails.orderDate }}
      </div>
    </div>
    <div class="col-sm-6">
      <div class="float-right">
        <button @click="download" type="button" class="btn btn-outline-oldevuuren download-order btn-round w-100">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-down"/>
          Download order
          <font-awesome-icon class="font-awesome-icon" v-if="isDownloadingOrder" icon="spinner" spin/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { DOWNLOAD_ORDER } from '../../store/types'

  export default {
    props: ['order'],
    data() {
      return {}
    },
    computed: {
      isDownloadingOrder() {
        return this.$store.getters.isDownloadingOrder
      },
      orderDetails() {
        return this.$store.getters.orderDetails
      }
    },
    methods: {
      download() {
        this.$store.dispatch(DOWNLOAD_ORDER, this.order)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
